<template>
  <v-switch
    :input-value="value"
    :loading="loading"
    :disabled="disabled"
    :class="[{ indeterminate }, 'toggle']"
    :color="trackColor"
    :ripple="!indeterminate"
    hide-details
    inset
    dense
    @change="handleChange"
  >
    <slot
      v-for="(_,name) in $slots"
      :slot="name"
      :name="name"
    />
  </v-switch>
</template>

<script>
  export default {
    name: 'Toggle',
    props: {
      value: Boolean,
      indeterminate: Boolean,
      loading: Boolean,
      disabled: Boolean,
      trackColor: {
        type: String,
        default: 'success',
      },
    },
    methods: {
      handleChange (value) {
        this.$emit('input', value)
        this.$emit('toggle', value)
      },
    },
  }
</script>

<style lang="scss">
.toggle {
  display: inline-block !important;
  .v-input--switch__track.theme--light {
      opacity: 1;
    }
    .v-input--switch__thumb.theme--light {
       background-color: white;
       box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.25);
    }
  &.indeterminate {
    &.theme--light.v-input--switch .v-input--switch__thumb {
      color: #FFF;
      transform: translate(10px, 0) !important;
    }
    &.theme--light.v-input--switch .v-input--switch__track {
      color: #E19B47;
      opacity: 1;
    }
  }
  &.v-input--selection-controls {
    margin: auto 0;
    padding-top: 0;
    &.success--text {
      color: $success !important;
    }
  }
  & .v-input--selection-controls__input {
    align-self: start;
  }
}
</style>
